import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

interface IconButtonState {
  onClickButton?: any;
  tooltipText: string;
  icon: any;
  color?: string;
  className?: string;
  disabled?: boolean;
  tabIndex?: number;
}

const IconButton = ({
  onClickButton = null,
  tooltipText,
  icon,
  color = "text-muted",
  className = "",
  disabled = false,
  tabIndex,
}: IconButtonState) => {
  return (
    <FontAwesomeIcon
      data-tooltip-id="tooltip"
      data-tooltip-content={tooltipText}
      icon={icon}
      color={color}
      tabIndex={tabIndex}
      onClick={!disabled ? onClickButton : undefined}
      className={`${color} me-1 ${disabled ? "cursor-not-allowed" : onClickButton ? "cursor-pointer" : ""} ${className}`}
    />
  );
};

export default IconButton;
